import React from 'react';
import {Col, Row} from "react-bootstrap";
import Form from "react-bootstrap/Form";
import DatePicker from 'react-date-picker';
import 'react-date-picker/dist/DatePicker.css';
import 'react-calendar/dist/Calendar.css';
import "../../layout/styles/components/date-picker.scss";

const ComboInputPeriodV2 = ({
                              propSearchParam = {},
                              propLabel = '조회기간',
                              propOnChangeStart = null,
                              propOnChangeEnd = null,
                              propOnChangeStartHour = "00",
                              propOnChangeEndHour = "23",
                              propLabelSize,
                              propInputSize
                            }) => {

  return (
      /*<Form.Group as={Row} className={""}>
          <Form.Label column md={propLabelSize} className={"label text-end"}>
              {propLabel}
          </Form.Label>

          <Col md={propInputSize}> {/!* 시작 그룹 영역 *!/}
              {propSearchParam.searchTerm === "H" ?
                  <Row>
                      <Col md={7}>
                          <DatePicker
                              onChange={propOnChangeStart}
                              value={propSearchParam.startDate}
                              format={propSearchParam.searchTerm === "M" ? "yyyy-MM" : "yyyy-MM-dd"}
                              maxDetail={propSearchParam.searchTerm === "M" ? "year" : "month"}
                              className={"datepicker-start w-100 text-center"}
                              clearIcon={null}
                              calendarType={'US'}
                              formatDay={
                                  (locale, date) => new Intl.DateTimeFormat(
                                      'en-US',
                                      {
                                          day: "numeric"
                                      }).format(date)
                              }
                          />
                      </Col>
                      <Col md={5} className={""}>
                          <Form.Select
                              aria-label="Default select example"
                              className={"input-select time pe-0"}
                              key={propSearchParam.searchFromSi || "00"}
                              defaultValue={propSearchParam.searchFromSi || "00"}
                              onChange={(e) => {
                                  propOnChangeStartHour(e.target.value);
                              }}
                          >
                              <option value={"00"}>00시</option>
                              <option value={"01"}>01시</option>
                              <option value={"02"}>02시</option>
                              <option value={"03"}>03시</option>
                              <option value={"04"}>04시</option>
                              <option value={"05"}>05시</option>
                              <option value={"06"}>06시</option>
                              <option value={"07"}>07시</option>
                              <option value={"08"}>08시</option>
                              <option value={"09"}>09시</option>
                              <option value={"10"}>10시</option>
                              <option value={"11"}>11시</option>
                              <option value={"12"}>12시</option>
                              <option value={"13"}>13시</option>
                              <option value={"14"}>14시</option>
                              <option value={"15"}>15시</option>
                              <option value={"16"}>16시</option>
                              <option value={"17"}>17시</option>
                              <option value={"18"}>18시</option>
                              <option value={"19"}>19시</option>
                              <option value={"20"}>20시</option>
                              <option value={"21"}>21시</option>
                              <option value={"22"}>22시</option>
                              <option value={"23"}>23시</option>
                          </Form.Select>
                      </Col>
                  </Row>
                  :
                  <Row>
                      <Col md={12}>
                          <DatePicker
                              onChange={propOnChangeStart}
                              value={propSearchParam.startDate}
                              format={propSearchParam.searchTerm === "M" ? "yyyy-MM" : "yyyy-MM-dd"}
                              maxDetail={propSearchParam.searchTerm === "M" ? "year" : "month"}
                              className={"datepicker-start w-100 text-center"}
                              clearIcon={null}
                              calendarType={'US'}
                              formatDay={
                                  (locale, date) => new Intl.DateTimeFormat(
                                      'en-US',
                                      {
                                          day: "numeric"
                                      }).format(date)
                              }
                          />
                      </Col>
                  </Row>}
          </Col>
          <Form.Label column md={1} className={"label text-center"}>
              ~
          </Form.Label>
          <Col md={propInputSize}> {/!* 종료 그룹 영역 *!/}
              {propSearchParam.searchTerm === "H" ?
                  <Row>
                      <Col md={7}>
                          <DatePicker
                              onChange={propOnChangeEnd}
                              value={propSearchParam.endDate}
                              format={propSearchParam.searchTerm === "M" ? "yyyy-MM" : "yyyy-MM-dd"}
                              maxDetail={propSearchParam.searchTerm === "M" ? "year" : "month"}
                              className={"datepicker-start w-100 text-center"}
                              clearIcon={null}
                              calendarType={'US'}
                              formatDay={
                                  (locale, date) => new Intl.DateTimeFormat(
                                      'en-US',
                                      {
                                          day: "numeric"
                                      }).format(date)
                              }
                          />
                      </Col>
                      <Col md={5} className={""}>
                          <Form.Select
                              aria-label="Default select example"
                              className={"input-select time pe-0"}
                              key={propSearchParam.searchToSi || "23"}
                              defaultValue={propSearchParam.searchToSi || "23"}
                              onChange={(e) => {
                                  propOnChangeEndHour(e.target.value);
                              }}
                          >
                              <option value={"00"}>00시</option>
                              <option value={"01"}>01시</option>
                              <option value={"02"}>02시</option>
                              <option value={"03"}>03시</option>
                              <option value={"04"}>04시</option>
                              <option value={"05"}>05시</option>
                              <option value={"06"}>06시</option>
                              <option value={"07"}>07시</option>
                              <option value={"08"}>08시</option>
                              <option value={"09"}>09시</option>
                              <option value={"10"}>10시</option>
                              <option value={"11"}>11시</option>
                              <option value={"12"}>12시</option>
                              <option value={"13"}>13시</option>
                              <option value={"14"}>14시</option>
                              <option value={"15"}>15시</option>
                              <option value={"16"}>16시</option>
                              <option value={"17"}>17시</option>
                              <option value={"18"}>18시</option>
                              <option value={"19"}>19시</option>
                              <option value={"20"}>20시</option>
                              <option value={"21"}>21시</option>
                              <option value={"22"}>22시</option>
                              <option value={"23"}>23시</option>
                          </Form.Select>
                      </Col>
                  </Row>
                  :
                  <Row>
                      <Col md={12}>
                          <DatePicker
                              onChange={propOnChangeEnd}
                              value={propSearchParam.endDate}
                              format={propSearchParam.searchTerm === "M" ? "yyyy-MM" : "yyyy-MM-dd"}
                              maxDetail={propSearchParam.searchTerm === "M" ? "year" : "month"}
                              className={"datepicker-start w-100 text-center"}
                              clearIcon={null}
                              calendarType={'US'}
                              formatDay={
                                  (locale, date) => new Intl.DateTimeFormat(
                                      'en-US',
                                      {
                                          day: "numeric"
                                      }).format(date)
                              }
                          />
                      </Col>
                  </Row>}
          </Col>
      </Form.Group>*/
      <Form.Group as={Row} className={""}>
        <Form.Label
            className={`col-form-label label text-end`}
            style={propLabelSize ? {} : {width: "100px"}}
            column={propLabelSize ? true : false}
            sm={propLabelSize}
        >
          {propLabel}
        </Form.Label>

        <Col xxl={4} xl={4} lg={4} md={9} sm={9}> {/* 시작 그룹 영역 */}
          {propSearchParam.searchTerm === "H" ?
              <Row>
                <Col lg={8} md={8} sm={6}>
                  <DatePicker
                      onChange={propOnChangeStart}
                      value={propSearchParam.startDate}
                      format={propSearchParam.searchTerm === "M" ? "yyyy-MM" : "yyyy-MM-dd"}
                      maxDetail={propSearchParam.searchTerm === "M" ? "year" : "month"}
                      className={"datepicker-start w-100 text-center"}
                      clearIcon={null}
                      calendarType={'US'}
                      formatDay={
                        (locale, date) => new Intl.DateTimeFormat(
                            'en-US',
                            {
                              day: "numeric"
                            }).format(date)
                      }
                  />
                </Col>
                <Col lg={4} md={4} sm={6}>
                  <Form.Select
                      aria-label="Default select example"
                      className={"input-select time pe-0"}
                      key={propSearchParam.searchFromSi || "00"}
                      defaultValue={propSearchParam.searchFromSi || "00"}
                      onChange={(e) => {
                        propOnChangeStartHour(e.target.value);
                      }}
                  >
                    <option value={"00"}>00시</option>
                    <option value={"01"}>01시</option>
                    <option value={"02"}>02시</option>
                    <option value={"03"}>03시</option>
                    <option value={"04"}>04시</option>
                    <option value={"05"}>05시</option>
                    <option value={"06"}>06시</option>
                    <option value={"07"}>07시</option>
                    <option value={"08"}>08시</option>
                    <option value={"09"}>09시</option>
                    <option value={"10"}>10시</option>
                    <option value={"11"}>11시</option>
                    <option value={"12"}>12시</option>
                    <option value={"13"}>13시</option>
                    <option value={"14"}>14시</option>
                    <option value={"15"}>15시</option>
                    <option value={"16"}>16시</option>
                    <option value={"17"}>17시</option>
                    <option value={"18"}>18시</option>
                    <option value={"19"}>19시</option>
                    <option value={"20"}>20시</option>
                    <option value={"21"}>21시</option>
                    <option value={"22"}>22시</option>
                    <option value={"23"}>23시</option>
                  </Form.Select>
                </Col>
              </Row>
              :
              <Row>
                <Col md={12}>
                  <DatePicker
                      onChange={propOnChangeStart}
                      value={propSearchParam.startDate}
                      format={propSearchParam.searchTerm === "M" ? "yyyy-MM" : "yyyy-MM-dd"}
                      maxDetail={propSearchParam.searchTerm === "M" ? "year" : "month"}
                      className={"datepicker-start w-100 text-center"}
                      clearIcon={null}
                      calendarType={'US'}
                      formatDay={
                        (locale, date) => new Intl.DateTimeFormat(
                            'en-US',
                            {
                              day: "numeric"
                            }).format(date)
                      }
                  />
                </Col>
              </Row>}
        </Col>
        <Form.Label column lg={1} className={"label text-center"}>
          ~
        </Form.Label>
        <Col xxl={4} xl={4} lg={4} md={9} sm={9}> {/* 종료 그룹 영역 */}
          {propSearchParam.searchTerm === "H" ?
              <Row>
                <Col lg={8} md={8} sm={6}>
                  <DatePicker
                      onChange={propOnChangeEnd}
                      value={propSearchParam.endDate}
                      format={propSearchParam.searchTerm === "M" ? "yyyy-MM" : "yyyy-MM-dd"}
                      maxDetail={propSearchParam.searchTerm === "M" ? "year" : "month"}
                      className={"datepicker-start w-100 text-center"}
                      clearIcon={null}
                      calendarType={'US'}
                      formatDay={
                        (locale, date) => new Intl.DateTimeFormat(
                            'en-US',
                            {
                              day: "numeric"
                            }).format(date)
                      }
                  />
                </Col>
                <Col lg={4} md={4} sm={6}>
                  <Form.Select
                      aria-label="Default select example"
                      className={"input-select time pe-0"}
                      key={propSearchParam.searchToSi || "23"}
                      defaultValue={propSearchParam.searchToSi || "23"}
                      onChange={(e) => {
                        propOnChangeEndHour(e.target.value);
                      }}
                  >
                    <option value={"00"}>00시</option>
                    <option value={"01"}>01시</option>
                    <option value={"02"}>02시</option>
                    <option value={"03"}>03시</option>
                    <option value={"04"}>04시</option>
                    <option value={"05"}>05시</option>
                    <option value={"06"}>06시</option>
                    <option value={"07"}>07시</option>
                    <option value={"08"}>08시</option>
                    <option value={"09"}>09시</option>
                    <option value={"10"}>10시</option>
                    <option value={"11"}>11시</option>
                    <option value={"12"}>12시</option>
                    <option value={"13"}>13시</option>
                    <option value={"14"}>14시</option>
                    <option value={"15"}>15시</option>
                    <option value={"16"}>16시</option>
                    <option value={"17"}>17시</option>
                    <option value={"18"}>18시</option>
                    <option value={"19"}>19시</option>
                    <option value={"20"}>20시</option>
                    <option value={"21"}>21시</option>
                    <option value={"22"}>22시</option>
                    <option value={"23"}>23시</option>
                  </Form.Select>
                </Col>
              </Row>
              :
              <Row>
                <Col md={12}>
                  <DatePicker
                      onChange={propOnChangeEnd}
                      value={propSearchParam.endDate}
                      format={propSearchParam.searchTerm === "M" ? "yyyy-MM" : "yyyy-MM-dd"}
                      maxDetail={propSearchParam.searchTerm === "M" ? "year" : "month"}
                      className={"datepicker-start w-100 text-center"}
                      clearIcon={null}
                      calendarType={'US'}
                      formatDay={
                        (locale, date) => new Intl.DateTimeFormat(
                            'en-US',
                            {
                              day: "numeric"
                            }).format(date)
                      }
                  />
                </Col>
              </Row>}
        </Col>
      </Form.Group>
  );
};

export default ComboInputPeriodV2;
